import { analytics } from '@luminovo/data-stack';
import type { SlotAnalyticsTrack } from '@luminovo/slots';

/**
 * Creates the analytics sink `@luminovo/slots` reports widget usage to.
 *
 * `analytics.track` is already a no-op until `initAnalytics` has run, which happens
 * only once production, the ITAR kill switch, the analytics cookie consent, and the
 * internal-user check all pass — so nothing here needs to re-check any of that.
 */
export function createSlotAnalyticsTrack(tenant: string): SlotAnalyticsTrack {
    return (event, properties) => {
        if (event === 'apps/widget_viewed') {
            analytics.track(event, properties, { context: { groupId: tenant } });
            return;
        }

        analytics.track(event, properties);
    };
}
